module.exports = __webpack_public_path__ + "static/media/The Terrace Alcoves 2.8c1359d8.jpg";